"use client";
import { ArrowLink, Col, Row } from "@/components";
import { Avatars } from "../Avatars";
import "./DelegationHomeBanner.scss";
type HomeBannerProps = {
  users: Array<any>;
  title?: string;
  linkLabel?: string;
  onChangeProfileClick?: () => void;
};
export function DelegationHomeBanner({
  users,
  title = "",
  linkLabel = "",
  onChangeProfileClick,
}: HomeBannerProps) {
  return (
    <Col
      br={"x4"}
      gap={"x16"}
      className={"delegation-home-banner bg-lightblue-a03 shadow"}
    >
      <h3 className="ui-banner-title text-slate-20 fs-4 fw-semibold">
        {title}
      </h3>
      <Row justifyContent="space-between">
        <Avatars users={users} maxVisible={4} />
        <ArrowLink
          arrowVisible={true}
          asButton
          onClick={onChangeProfileClick}
          className="cursor-pointer"
        >
          {linkLabel}
        </ArrowLink>
      </Row>
    </Col>
  );
}
